import React, { useState } from 'react';
import { Card, Row, Col, Modal, Button, Form, Spinner, InputGroup, FormLabel } from 'react-bootstrap';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import 'dayjs/locale/es';
import { getCoreRowModel } from '@tanstack/react-table';
import { getExpandedRowModel } from '@tanstack/react-table';
import { useReactTable } from '@tanstack/react-table';
import { flexRender } from '@tanstack/react-table';
import { getPaginationRowModel } from '@tanstack/react-table';
import { getFilteredRowModel } from '@tanstack/react-table';
import { GoogleMapsProvider } from '../../../../../providers/GoogleMapsProvider';
import { FaMapMarkerAlt, FaPlayCircle, FaSearch, FaFileExport, FaAngleRight, FaAngleLeft, FaAngleDoubleRight, FaAngleDoubleLeft } from 'react-icons/fa';
//import GoogleMapComponent from "../../../../../components/common/GoogleMap";
//import GoogleMapsRoutesMarks from '../../../../../components/common/google-maps-advance-marks/GoogleMapsRoutesMarks';
import GoogleMapSelector, { obtenerInfoViewTop } from '../../../../../components/common/google-maps-selector/GoogleMapSelector';
import IconButton from '../../../../../components/common/IconButton';
import { obtenerIconoAlerta } from '../../../../../components/common/google-maps-selector/IconosTabla';
import iconoPng from '../../../../../assets/img/icons/export.png';
import * as XLSX from 'xlsx'

// Activamos el soporte para formatos personalizados
dayjs.extend(customParseFormat);
dayjs.locale('es');

const formatFecha = (fechaStr) => {
    if (!fechaStr || typeof fechaStr !== 'string') return ' ';

    try {
        return dayjs(fechaStr, 'YYYY-MM-DD- HH:mm:ss').format('DD/MM/YYYY');
    } catch (error) {
        console.error('Error al formatear la fecha:', error);
        return 'N/A';
    }
};

const formatHora = (fechaStr) => {
    if (!fechaStr || typeof fechaStr !== 'string') return ' ';

    try {
        return dayjs(fechaStr, 'YYYY-MM-DD- HH:mm:ss').format('hh:mm A');
    } catch (error) {
        console.error('Error al formatear la fecha:', error);
        return 'N/A';
    }
};

const NoAutorizadosMasterDetailList = ({ data = [], perPage = 10, title, isGroup, searchValue = '', onSearch }) => {
    const customStyles = {
        minWidth: '70px',
        minHeight: '30px',
        maxHeight: '30px',
        fontSize: '12px',
        overflow: 'hidden',
        appearance: 'none',
        WebkitAppearance: 'none',
        MozAppearance: 'none',
        backgroundColor: 'white',
        border: '1px solid #ccc',
        paddingRight: '20px',
        paddingLeft: '10px',
        backgroundImage: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' fill='lightgrey' viewBox='0 0 24 24'><path d='M12 15.41 6.41 9.83 7.83 8.41 12 12.59 16.17 8.41 17.59 9.83z'/></svg>")`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'right 5px center',
        backgroundSize: '25px',
    };
    const safeTableData = Array.isArray(data) ? data : [];

    // Estado para manejar el modal del mapa
    const [globalFilter, setGlobalFilter] = useState(searchValue);
    const [mapTitle, setMapTitle] = useState('');
    const [expanded, setExpanded] = useState(false);
    const [showMapModal, setShowMapModal] = useState(false);
    const [selectedLocation, setSelectedLocation] = useState({ lat: null, lng: null });
    const [selectedLocations, setSelectedLocations] = useState([]);
    const [infoView, setInfoView] = useState(null);

    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: perPage,
    });

    // Función para abrir el modal con la latitud y longitud seleccionadas

    const handleShowMap = (alerta) => { // Para master
        //let firstMarker = alerta.markers[0];
        setInfoView(null);
        if (alerta.markers) {
            if (alerta.markers.length > 0) {
                var tipos = [];
                let arr = alerta.children.map((m, index) => {
                    let icono = obtenerIconoAlerta(m.alerta.toLowerCase().includes('apagado') ? 55 : 6);
                    let infoViewTop = obtenerInfoViewTop({
                        markerId: index,
                        titulo: m.no_economico || '',
                        colorFondoTitulo: m.color_vehiculo || 'black',
                        colorTextoTitulo: 'text-white',
                        velocidad: m.velocidad || '',
                        alerta: m.alerta_real || '',
                        fecha: dayjs(m.fecha).format('DD/MM/YYYY HH:mm:ss') || '',
                        ruta: m.distancia ? (m.distancia).toFixed(3) : 'N/A',
                        chofer: m.chofer || 'N/A'
                    });
                    if (!tipos.includes(m.alerta)) {
                        tipos.push(m.alerta);
                    }
                    return ({ lat: m.latitud, lng: m.longitud, icon: icono, infoViewTop: infoViewTop })
                });
                let titleStr = tipos.filter(s => s).join(' / ');
                setMapTitle(titleStr);
                setSelectedLocation(arr[0]);
                setSelectedLocations(arr);
            }
            setShowMapModal(true);
        }
    };

    const handleShowMapUnique = (lat, lng, latFin, lngFin, tipoAlerta, m) => { // individual

        let icono = obtenerIconoAlerta(tipoAlerta === 'A' ? 55 : 6);
        setInfoView(obtenerInfoViewTop({
            markerId: 0,
            titulo: m.no_economico || '',
            colorFondoTitulo: m.color_vehiculo || 'black',
            colorTextoTitulo: 'text-white',
            velocidad: m.velocidad || '',
            alerta: m.alerta_real || '',
            fecha: dayjs(m.fecha).format('DD/MM/YYYY HH:mm:ss') || '',
            ruta: m.distancia ? (m.distancia).toFixed(3) : 'N/A',
            chofer: m.chofer || 'N/A'
        }));
        setSelectedLocation({ lat: lat, lng: lng, icon: icono });
        setSelectedLocations([{ lat: lat, lng: lng, tipo_alerta: tipoAlerta, icon: icono }, { lat: latFin, lng: lngFin, tipo_alerta: tipoAlerta, icon: icono }]);
        setShowMapModal(true);
    };

    const style1Lines = {
        display: "-webkit-box",
        WebkitLineClamp: 1,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "normal",
    };
    // Estructura de columnas 
    const columns = [
        {
            header: ' ',
            cell: ({ row }) => {
                return row.getCanExpand() ?
                    <IconButton
                        variant="falcon-default"
                        size="sm"
                        icon={row.getIsExpanded() ? "chevron-up" : "chevron-down"}
                        transform="shrink-3"
                        onClick={row.getToggleExpandedHandler()}
                    />
                    : '';
            },
        },
        {
            accessorKey: 'no_economico',
            header: 'Vehículo',
            meta: { headerProps: { className: 'text-900' } },
            cell: ({ row: { original }, row }) => {
                const isCollapsable = row.getCanExpand();
                const value = original.no_economico || '';
                return (
                    <Row>
                        <Col className={isCollapsable ? "fw-bold" : ""}>
                            <span style={{ ...style1Lines }} title={value}>{value}</span>
                        </Col>
                    </Row>
                );
            },
        },
        {
            accessorKey: 'fecha',
            header: 'Fecha',
            cell: ({ row: { original } }) => (
                <span >
                    {formatFecha(original.fecha)}
                </span>
            ),
            meta: { headerProps: { className: 'text-900' } }
        },
        {
            accessorKey: 'hora',
            header: 'Hora',
            cell: ({ row: { original }, row }) => {
                const isCollapsable = row.getCanExpand();
                const value = formatHora(original.fecha) || '';
                return (
                    <Row>
                        <Col className={isCollapsable ? "fw-bold" : ""}>
                            <span style={{ ...style1Lines, minWidth: '70px' }} title={value}>{value}</span>
                        </Col>
                    </Row>
                );
            },
            meta: { headerProps: { className: 'text-900' } }
        },
        {
            accessorKey: 'detenido',
            header: 'Detenido',
            meta: { headerProps: { className: 'text-900' } },
            cell: ({ row: { original }, row }) => {
                const isCollapsable = row.getCanExpand();
                const value = original.detenido || '';
                return (
                    <Row>
                        <Col className={isCollapsable ? "fw-bold" : ""}>
                            <span style={{ ...style1Lines, minWidth: '160px' }} title={value}>{value}</span>
                        </Col>
                    </Row>
                );
            },
        },
        {
            accessorKey: 'apagado',
            header: 'Apagado',
            meta: { headerProps: { className: 'text-900' } },
            cell: ({ row: { original }, row }) => {
                const isCollapsable = row.getCanExpand();
                const value = original.apagado || '';
                return (
                    <Row>
                        <Col className={isCollapsable ? "fw-bold" : ""}>
                            <span style={{ ...style1Lines, minWidth: '160px' }} title={value}>{value}</span>
                        </Col>
                    </Row>
                );
            },
        },
        {
            accessorKey: 'geocerca',
            header: 'Marcardor',
            meta: { headerProps: { className: 'text-900' } }
        },
        {
            accessorKey: "mapa",
            header: "Ubicacion",
            cell: ({ row: { original } }) => {
                // Determina la función onClick según la condición
                const handleClick = original.isMaster && original.isMaster === true
                    ? () => handleShowMap(original)
                    : () => handleShowMapUnique(
                        parseFloat(original.latitud),
                        parseFloat(original.longitud),
                        parseFloat(original.latitud),
                        parseFloat(original.longitud),
                        original.tipo_alerta === "6091ba3e662e2b2e74500a43" ? "D" : "A",
                        original
                    );

                return (
                    <a
                        href='#!'
                        onClick={(e) => {
                            // Asigna la función determinada
                            e.preventDefault();
                            handleClick();
                        }}
                    >
                        <FaMapMarkerAlt className="text-danger" />
                    </a>
                );
            },
            meta: {
                headerProps: { className: "text-900 text-center" },
                cellProps: { className: "text-center" },
            },
        }

    ]

    // --- INICIO CAMBIO: Filtro global personalizada que busca en subrows ---
    function customGlobalFilter(row, columnId, filterValue) {
        const original = row.original;
        const formattedFecha = formatFecha(original.fecha);
        const formattedHora = formatHora(original.fecha);
        // Concatenar todos los valores de las columnas principales
        const valuesToSearch = [
            original.no_economico,
            formattedFecha,
            formattedHora,
            original.detenido,
            original.apagado,
            original.geocerca,
        ]
            .filter(Boolean)
            .join(' ')
            .toLowerCase();
        // Buscar en los hijos (children) si existen
        let childrenMatch = false;
        if (Array.isArray(original.children)) {
            childrenMatch = original.children.some(child => {
                const childFormattedFecha = formatFecha(child.fecha);
                const childFormattedHora = formatHora(child.fecha);
                const childValuesToSearch = [
                    child.no_economico,
                    childFormattedFecha,
                    childFormattedHora,
                    child.detenido,
                    child.apagado,
                    child.geocerca,
                    child.alerta,
                    child.alerta_real,
                    // Agrega más campos si lo deseas
                ]
                    .filter(Boolean)
                    .join(' ')
                    .toLowerCase();
                return childValuesToSearch.includes(filterValue.toLowerCase());
            });
        }
        // Coincide si el valor está en la fila principal o en algún hijo
        return valuesToSearch.includes(filterValue.toLowerCase()) || childrenMatch;
    }
    // --- FIN CAMBIO ---

    const table = useReactTable({
        data: safeTableData,
        columns,
        sortable: true,
        pagination: true,
        perPage,
        state: {
            globalFilter,
            pagination,
        },
        onGlobalFilterChange: setGlobalFilter,
        onPaginationChange: setPagination,
        getCoreRowModel: getCoreRowModel(),
        getPaginationRowModel: getPaginationRowModel(),
        getFilteredRowModel: getFilteredRowModel(),
        getSubRows: (row) => row.children,
        getExpandedRowModel: getExpandedRowModel(),
        enableGlobalFilter: true,
        debugTable: false,
        enableColumnFilters: false,
        // --- INICIO CAMBIO: Usar filtro global personalizado ---
        globalFilterFn: customGlobalFilter,
        // --- FIN CAMBIO ---
    });

    // Manejar el cambio en la búsqueda global
    const handleSearchChange = (e) => {
        const value = e.target.value;
        setGlobalFilter(value);
        if (onSearch) onSearch(value);
        // Resetear a la primera página cuando se busca
        setPagination(prev => ({ ...prev, pageIndex: 0 }));
    };

    const Filter = function ({ column, table }) {
        const firstValue = table
            .getPreFilteredRowModel()
            .flatRows[0]?.getValue(column.id)
        const columnFilterValue = column.getFilterValue()

        return typeof firstValue === "number" ? (
            <div className="flex space-x-2">
                <input
                    type="number"
                    value={columnFilterValue?.[0] ?? ""}
                    onChange={e => column.setFilterValue(old => [e.target.value, old?.[1]])}
                    placeholder={`Min`}
                    className="w-24 border shadow rounded"
                />
            </div>
        ) : (
            <input
                type="text"
                value={columnFilterValue ?? ""}
                onChange={e => column.setFilterValue(e.target.value)}
                placeholder={`Search...`}
                className="w-36 border shadow rounded"
            />
        )
    }

    //Pluigin XLSX para generar libro de excel
    const creandoArchivo = (dataFinal) => {
        if (window['guardarBitacoraExport']) {
            try {
                window['guardarBitacoraExport']();
            } catch (error) {

            }
        }
        const libro = XLSX.utils.book_new();

        const hoja = XLSX.utils.json_to_sheet(dataFinal, { skipHeader: true });

        const _totalFilas = dataFinal.length + 1
        const longitudes = [];

        hoja["!merges"] = [
            XLSX.utils.decode_range("A1:E1"),
            XLSX.utils.decode_range("A2:E2"),
            //XLSX.utils.decode_range(`A${_totalFilas}:E${_totalFilas}`),
        ];

        let propiedades = [];

        longitudes.forEach((col) => {
            propiedades.push({
                width: col,
            });
        });

        hoja["!cols"] = propiedades;

        XLSX.utils.book_append_sheet(libro, hoja, "Eventos");

        XLSX.writeFile(libro, "ReporteParadasNoAutorizadas.xlsx");
    };

    //Funcion para formatear la data de un documento en formato excel 
    const exportarDatos = () => {

        const titulo = [{ A: 'Reporte de paradas no autorizadas' }, {}]

        let tabla = [
            {
                A: 'Vehiculo',
                B: 'Fecha',
                C: 'Hora',
                D: 'Evento',
                E: 'Alerta',
                F: 'Marcador'
            }
        ]

        safeTableData.forEach((i) => {

            if (i.children) {

                i.children.forEach((sub) => {

                    tabla.push({
                        A: i.no_economico,
                        B: formatFecha(sub.fecha),
                        C: formatHora(sub.fecha),
                        D: sub.alerta || '',
                        E: sub.alerta_real || '',
                        F: i.geocerca
                    })

                })

            }

        })

        const dataFinal = [...titulo, ...tabla]

        setTimeout(() => {
            creandoArchivo(dataFinal);
            //setLoading(false);
        }, 1000);
    }

    //Evento para exportar a excel
    const handleExportar = () => {

        exportarDatos()
    }

    return (
        <Card className="h-100">

            <Card.Header>
                <Row className="d-flex align-items-center justify-content-between">
                    <Col md={6}>
                        <h6 className="mb-0 text-nowrap py-2 py-xl-0">{title}</h6>
                    </Col>

                    <Col md={4} className="d-flex justify-content-end align-items-center">

                        <Button
                            variant="primary"
                            size="sm"
                            className="me-2 p-2"
                            onClick={handleExportar}
                        >
                            <img
                                src={iconoPng}
                                alt="Exportar" title='Exportar a Excel'
                                style={{ width: '20px', height: '20px', filter: 'brightness(0) invert(1)' }} // Ajusta el tamaño
                                className="me-1 ms-1"
                            />
                        </Button>

                        <InputGroup size="sm" style={{ maxWidth: 200 }}>

                            <Form.Control
                                className='p-2'
                                type="text"
                                placeholder="Buscar..."
                                value={globalFilter || ''}
                                onChange={handleSearchChange}
                            />
                            {globalFilter && (
                                <Button
                                    variant="outline-secondary"
                                    onClick={() => {
                                        setGlobalFilter('');
                                        if (onSearch) onSearch('');
                                    }}
                                >
                                    &times;
                                </Button>
                            )}
                        </InputGroup>
                    </Col>
                    <Col md={2}>

                        <Form className='d-flex p-2 justify-content-end'>
                            <Form.Select
                                className='p-2'
                                size="sm"
                                style={{ width: '100px' }}
                                value={table.getState().pagination.pageSize}
                            >
                                <option value="50">50</option>
                                <option value="100">100</option>
                                <option value="250">250</option>
                                <option value="500">500</option>
                                <option value="1000">1000</option>
                            </Form.Select>

                        </Form>
                    </Col>
                </Row>
            </Card.Header>

            <Card.Body className='py-0 ps-0 pe-0 overflow-auto'>
                <GoogleMapsProvider>
                    <table className='fs-10 mb-0 overflow-hidden table table-striped'>
                        <thead className='text-nowrap align-middle'>
                            {table.getHeaderGroups().map(headerGroup => (
                                <tr key={headerGroup.id}>
                                    {headerGroup.headers.map(header => {
                                        return (
                                            <th key={header.id} colSpan={header.colSpan}>
                                                {header.isPlaceholder ? null : (
                                                    <div>
                                                        {flexRender(
                                                            header.column.columnDef.header,
                                                            header.getContext()
                                                        )}

                                                        {header.column.getCanFilter() ? (
                                                            <div>
                                                                <Filter column={header.column} table={table} />
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                )}
                                            </th>
                                        )
                                    })}
                                </tr>
                            ))}
                        </thead>
                        <tbody>
                            {table.getRowModel().rows.map(row => {
                                return (
                                    <tr key={row.id}>
                                        {row.getVisibleCells().map(cell => {
                                            return (
                                                <td key={cell.id}>
                                                    {flexRender(
                                                        cell.column.columnDef.cell,
                                                        cell.getContext()
                                                    )}
                                                </td>
                                            )
                                        })}
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>

                    {/* Modal para ver el mapa */}
                    <Modal
                        show={showMapModal}
                        onHide={() => setShowMapModal(false)}
                        size="lg"
                        centered
                    >
                        <Modal.Header closeButton>
                            <Modal.Title>Evento: {mapTitle || ''}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {infoView}
                            {selectedLocation.lat && selectedLocation.lng ? (
                                <GoogleMapSelector
                                    initialCenter={{
                                        lat: selectedLocation.lat,
                                        lng: selectedLocation.lng,
                                    }}
                                    zoomDefault={13}
                                    mapStyle="Default"
                                    markers={selectedLocations}
                                    className="vh-50"
                                    showStreetView={false}
                                />
                            ) : (
                                <div>
                                    <p>Ubicación no disponible</p>
                                </div>
                            )}
                        </Modal.Body>
                    </Modal>
                </GoogleMapsProvider>
            </Card.Body>

            <Card.Footer className="bg-white">
                <div className="d-flex justify-content-between align-items-center flex-wrap">
                    <div className="d-flex align-items-center">
                        <span className="me-2">
                            Total: {table.getFilteredRowModel().rows.length} | Página {table.getState().pagination.pageIndex + 1} de {table.getPageCount()}
                        </span>
                        <Form.Control
                            type="number"
                            min="1"
                            max={table.getPageCount()}
                            value={table.getState().pagination.pageIndex + 1}
                            onChange={e => {
                                const page = e.target.value ? Number(e.target.value) - 1 : 0;
                                table.setPageIndex(page);
                            }}
                            style={{ width: '70px', height: '31px' }}
                            size="sm"
                        />
                    </div>
                    <div className="d-flex justify-content-center">
                        <Button
                            variant="outline-dark"
                            size="sm"
                            className="mx-1"
                            onClick={() => table.setPageIndex(0)}
                            disabled={!table.getCanPreviousPage()}
                        >
                            <FaAngleDoubleLeft />
                            {/* &laquo; Primera */}
                        </Button>
                        <Button
                            variant="outline-dark"
                            size="sm"
                            className="mx-1"
                            onClick={() => table.previousPage()}
                            disabled={!table.getCanPreviousPage()}
                        >
                            <FaAngleLeft />
                            {/* &lt; Anterior */}
                        </Button>

                        {/* Mostrar números de página (5 páginas alrededor de la actual) */}
                        {(() => {
                            // Determinar qué páginas mostrar
                            let pagesArray = [];
                            if (table.getPageCount() <= 5) {
                                // Si hay 5 o menos páginas, mostrarlas todas
                                pagesArray = Array.from({ length: table.getPageCount() }, (_, i) => i);
                            } else if (table.getState().pagination.pageIndex <= 2) {
                                // Si estamos en las primeras páginas
                                pagesArray = [0, 1, 2, 3, 4];
                            } else if (table.getState().pagination.pageIndex >= table.getPageCount() - 3) {
                                // Si estamos en las últimas páginas
                                pagesArray = [
                                    table.getPageCount() - 5,
                                    table.getPageCount() - 4,
                                    table.getPageCount() - 3,
                                    table.getPageCount() - 2,
                                    table.getPageCount() - 1
                                ];
                            } else {
                                // Estamos en medio, mostrar 2 antes y 2 después
                                pagesArray = [
                                    table.getState().pagination.pageIndex - 2,
                                    table.getState().pagination.pageIndex - 1,
                                    table.getState().pagination.pageIndex,
                                    table.getState().pagination.pageIndex + 1,
                                    table.getState().pagination.pageIndex + 2
                                ];
                            }

                            return pagesArray.map(pageNum => (
                                <Button
                                    key={`page-${pageNum}`}
                                    variant={pageNum === table.getState().pagination.pageIndex ? "primary" : "outline-dark"}
                                    size="sm"
                                    className="mx-1"
                                    onClick={() => table.setPageIndex(pageNum)}
                                >
                                    {pageNum + 1}
                                </Button>
                            ));
                        })()}

                        <Button
                            variant="outline-dark"
                            size="sm"
                            className="mx-1"
                            onClick={() => table.nextPage()}
                            disabled={!table.getCanNextPage()}
                        >
                            {/* Siguiente &gt; */}
                            <FaAngleRight />
                        </Button>
                        <Button
                            variant="outline-dark"
                            size="sm"
                            className="mx-1"
                            onClick={() => table.setPageIndex(table.getPageCount() - 1)}
                            disabled={!table.getCanNextPage()}
                        >
                            {/* Última &raquo; */}
                            <FaAngleDoubleRight />
                        </Button>
                    </div>
                </div>
            </Card.Footer>
        </Card>
    );
};

export default NoAutorizadosMasterDetailList;